import MobileDeveloperPage from "./MobileDeveloperPage";

export default function FlutterDeveloperPage() {
  return <MobileDeveloperPage technology="flutter" />;
}
